import { getJson, postJson } from '../utilities/fetch';
import { ApiResult, apiResult } from './api';

export const createSecurityApi = (props?: { server?: string }) => {
    const baseUri = `${props?.server ?? ''}/api/security`;
    const baseUriAnon = `${props?.server ?? ''}/api/registration/new-member`;

    // Manage primary email

    type CheckPrimaryEmailStatus = {
        newEmail:
            | {
                  address: string;
                  isAwaitingVerification: boolean;
                  isAwaitingApproval: boolean;
              }
            | null;
    };

    const checkPrimaryEmailStatus = async () => {
        const uri = `${baseUri}/manage-emails/primary`;
        const result = await getJson({ uri });
        return apiResult(result) as ApiResult<CheckPrimaryEmailStatus>;
    };

    const changePrimaryEmail = async (
        emailType: string,
        emailAddress: string,
        password: string,
    ) => {
        const uri = `${baseUri}/manage-emails/primary/change`;
        const data = {
            emailType,
            emailAddress,
            password,
        };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };

    const confirmPrimaryEmailCode = async (verificationCode: string) => {
        const uri = `${baseUri}/manage-emails/primary/confirm/code`;
        const data = { verificationCode };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };

    const approveNewPrimaryEmail = async () => {
        const uri = `${baseUri}/manage-emails/primary/approve`;
        const result = await postJson({ uri });
        return apiResult(result);
    };

    // Manage alternate emails

    type CheckAlternateEmailStatus = {
        emails: [
            {
                address: string;
                isAwaitingVerification: string;
            }
        ];
    };

    const checkAlternateEmailStatus = async () => {
        const uri = `${baseUri}/manage-emails/alternate`;
        const result = await getJson({ uri });
        return apiResult(result) as ApiResult<CheckAlternateEmailStatus>;
    };

    const addAlternateEmail = async (newEmailAddress: string) => {
        const uri = `${baseUri}/manage-emails/alternate/add`;
        const data = { newEmailAddress };
        const result = await postJson({ uri, data });
        return apiResult(result);
    }

    const removeAlternateEmail = async (emailAddress: string) => {
        const uri = `${baseUri}/manage-emails/alternate/remove`;
        const data = { emailAddress };
        const result = await postJson({ uri, data });
        return apiResult(result);
    }

    // Confirm email links

    const confirmEmailLink = async (emailVerificationId: string) => {
        const uri = `${baseUri}/manage-emails/confirm/link`;
        const data = { emailVerificationId };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };

    // Manage account password

    const changePassword = async (newPassword: string, password: string) => {
        const uri = `${baseUri}/manage-password/change`;
        const data = { newPassword, password };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };

    const requestPasswordReset = async (passwordResetEmail: string) => {
        //const uri = `${baseUri}/manage-password/email-reset`;
        const uri = `${baseUriAnon}/email-reset`;

        const data = { passwordResetEmail };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };

    const completePasswordReset = async (
        passwordResetId: string,
        newPassword: string,
    ) => {
        //const uri = `${baseUri}/manage-password/email-reset/complete`;
        const uri = `${baseUriAnon}/email-reset/complete`;
        const data = { passwordResetId, newPassword };
        const result = await postJson({ uri, data });
        return apiResult(result);
    };


    return {
        checkPrimaryEmailStatus,
        changePrimaryEmail,
        confirmPrimaryEmailCode,

        approveNewPrimaryEmail,

        checkAlternateEmailStatus,
        addAlternateEmail,
        removeAlternateEmail,

        // Note: Confirms both primary and alternate email
        confirmEmailLink,

        changePassword,
        requestPasswordReset,
        completePasswordReset,
    };
};

export const securityApi = createSecurityApi();
